import { httpClient } from "@/services/httpClient";

const END_POINT = "/exam";

export const exam = {
  get(id) {
    return httpClient.get(`${END_POINT}/${id}`);
  },
  findAll() {
    return httpClient.get(`${END_POINT}`);
  },
  create(payload) {
    return httpClient.post(`${END_POINT}`, payload);
  },
};
